const initialState = { 
  loading: false,
  success: null,
  error: null
}

function finishTransactionReducer(state = initialState, action) {
  switch (action.type) {
    case 'FINISH_TRANSACTION_SGH_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'FINISH_TRANSACTION_SGH_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'FINISH_TRANSACTION_SGH_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default finishTransactionReducer